/**
 * Error panel — rose stripe + OctagonAlert icon. Schema mirrors the
 * rest of the named-panel set; visual identity comes from NAMED_PANELS.
 */

import { buildNamedPanelView } from './NamedPanelView'
import { buildPanelExtension } from './panel-extension-factory'
import { NAMED_PANELS } from './panel-kinds'

const spec = NAMED_PANELS.find((p) => p.kind === 'error')
if (!spec) throw new Error('NAMED_PANELS missing error kind — registry shape changed')

export const ErrorPanel = buildPanelExtension({
  name: spec.nodeName,
  dataBlockType: spec.dataBlockType,
  view: buildNamedPanelView(spec),
})
